<app-header></app-header>
<app-botao-chat></app-botao-chat>

<div class="container py-4">
  <!-- CONTEÚDO -->
  <div class="row">
    <div class="col-12 col-lg-8 mb-4 mb-lg-0">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        @if (noticia) {
          <div class="row">
            <div class="col-12">
              <h1 class="titulo-noticia">{{noticia.resumoNoticia}}</h1>
              <span class="data-noticia-especifica"><i class="fa fa-calendar me-2" aria-hidden="true"></i>{{noticia.dataDaNoticia | appDate: 'dd/MM/yyyy'}}</span>
              <span class="voltar-todas-noticias" routerLink="/noticias">Voltar para todas as notícias</span>
              <br><br>
            </div>
          </div>
        }
        <div class="row">
          <div class="col-12">
            <div id="conteudoNoticia">
              <!-- AQUI VAI O CONTEÚDO DA NOTICIA - ESCREVO ELE VIA JAVASCRIPT POIS VEM CÓDIGO HTML-->
            </div>
          </div>
        </div>

        @if (noticia === null) {
          <div class="row">
            <div class="col-12">
              <div class="text-center">
                <output class="spinner-border c-primary">
                  <span class="visually-hidden">Consultando detalhes da notícia ...</span>
                </output>
              </div>
              <p class="legenda-spinner">Consultando detalhes da notícia ...</p>
            </div>
          </div>
        }

        @if (noticia === false) {
          <div class="row">
            <div class="text-center">
              <img src="/assets/img/erro.png" alt="representando erro na consulta dos detalhes da notícia" width="200px">
              <p class="legenda-erro">Ocorreu um erro na consulta de detalhes da notícia.</p>
            </div>
          </div>
        }

      </div>
    </div>
    <!-- DIV LATERAL COM AS DICAS E INFORMAÇÕES E DOWNLOAD DE ARQUIVOS, apenas algo estático -->
    <div class="col-12 col-lg-4">
      <div class="card">
        <h3 class="titulo-card-lateral">BUSCAR NOS INFORMATIVOS</h3>
        <div class="input-group align-items-center">
          <input type="text" class="form-control sombra" (keyup.enter)="buscaNoticias()" [(ngModel)]="inputBusca" placeholder="Buscar">
          <button class="btn-icon" (click)="buscaNoticias()">
            <i class="fa fa-search c-gray icone-lupa" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <div class="card my-4">
        <h3 class="titulo-card-lateral">FILTROS</h3>
        <button class="botao-noticia mb-3" (click)="voltarPaginaNoticias('')">Informações em Geral</button>
        <button class="botao-noticia mb-3" (click)="voltarPaginaNoticias('reajuste')">Reajuste de Tarifa</button>
        <button class="botao-noticia mb-3" (click)="voltarPaginaNoticias('migracao')">Migrações de Operadoras</button>
        <button class="botao-noticia mb-3" (click)="voltarPaginaNoticias('data')">Por data</button> <br>
      </div>
      <img class="d-none d-lg-block mb-3 rounded" src="/assets/img/banner_rc.jpg" alt="banner representando uma propaganda do vt" width="100%">
    </div>

    <!-- ÚLTIMAS IMPORTAÇÕES TABLEA -->
    <div class="col-12 mt-3">
      <div class="card">
        <h3 class="titulo-ultimas-importacoes">Veja também</h3>
        <h4 class="paragrafo-card mb-3">Fique sabendo de todas as novidades que relacionadas a Gestão de Vale-Transporte e Mobilidade</h4>

        @if (noticias) {
          <div class="row">
            @for (noticia of noticias; track noticia) {
              <div class="col-4 pe-4">
                <h4 class="titulo-noticia">{{noticia.resumoNoticia}}</h4>
                <p class="descricao-noticia">{{noticia.descAssuntoNoticia}}</p>
                  <div class="news-content">
                    <span class="data-noticia"><i class="fa fa-calendar me-2" aria-hidden="true"></i>{{noticia.dataDaNoticia | appDate: 'dd/MM/yyyy'}}</span>
                    <button class="veja-mais-noticia btn-icon" (click)="detalharNoticias(noticia.idNoticia)">Veja mais</button>
                  </div>                
              </div>
            }
          </div>
        }

        @if (noticias === null) {
          <div class="row">
            <div class="col-12">
              <div class="text-center">
                <output class="spinner-border c-primary">
                  <span class="visually-hidden">Consultando notícias ...</span>
                </output>
              </div>
              <p class="legenda-spinner">Consultando notícias ...</p>
            </div>
          </div>
        }

        @if (noticias === false) {
          <div class="row">
            <div class="text-center">
              <img src="/assets/img/erro.png" alt="Erro na consulta de notícias" width="230px">
              <p class="legenda-erro">Ocorreu um erro na consulta das notícias.</p>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
